export const QUEUE_SOCKET = {
    SOCKET_CONNECT_NEW: "SOCKET_CONNECT_NEW",
    MSA_EXIT_ROOM: "MSA_EXIT_ROOM",
    MSA_JOIN_ROOM: "MSA_JOIN_ROOM",
    QUEUE_NEXT_CALLING: "QUEUE_NEXT_CALLING",
    QUEUE_DONOR_CALLING: "QUEUE_DONOR_CALLING",
    QUEUE_DONOR_PENDING: "QUEUE_DONOR_PENDING",
    QUEUE_DONOR_CREATED: "QUEUE_DONOR_CREATED",
    QUEUE_DONOR_SWITCHED: "QUEUE_DONOR_SWITCHED",
    ADD_MEDICAL_NEXT: "ADD_MEDICAL_NEXT",
    ADD_MEDICAL_NOW: "ADD_MEDICAL_NOW",
    ROOM_INFO_UPDATED: "ROOM_INFO_UPDATED",
    ROOM_PASSED_DONOR: "ROOM_PASSED_DONOR",
    ROOM_CREATED: "ROOM_CREATED",
    FLOOR_INFO_UPDATED: "FOOR_INFO_UPDATED",
    FLOOR_PASSED_DONOR: "FLOOR_PASSED_DONOR",
    FLOOR_CREATED: "FLOOR_CREATED",
    FLOOR_CHANGE_DEVICE: "FLOOR_CHANGE_DEVICE",
    FLOOR_BIND_EQUIP: "FLOOR_BIND_EQUIP",
    FLOOR_UNBIND_EQUIP: "FLOOR_UNBIND_EQUIP",
    FLOOR_BIND_OTHER_EQUIP: "FLOOR_BIND_OTHER_EQUIP",
    FLOOR_UNBIND_OTHER_EQUIP: "FLOOR_UNBIND_OTHER_EQUIP",
    DONOR_VISIT_CANCEL: "DONOR_VISIT_CANCEL",
    DONOR_DEFERRAL_ADDED: "DONOR_DEFERRAL_ADDED",
    CHECK_RECORD_PROCESS_CHANGED: "CHECK_RECORD_PROCESS_CHANGED",
    CHECK_RECORD_CONFIRM_END: "CHECK_RECORD_CONFIRM_END",
    CHECK_RECORD_RETAKE: "CHECK_RECORD_RETAKE",
    COLLECTION_PROCESS_CHANGED: "COLLECTION_PROCESS_CHANGED",
}